import './index.scss'

document.addEventListener("DOMContentLoaded", () => {
    const marquee = document.querySelector(".marquee");
    const inner = marquee.querySelector(".marquee__inner");
    const text = inner.dataset.text;

    function buildMarquee() {
        inner.innerHTML = "";
        
        const span = document.createElement("span");
        span.textContent = text;
        inner.appendChild(span);

        const textWidth = span.offsetWidth;
        const screenWidth = window.innerWidth;

        const repeatCount = Math.ceil((screenWidth * 2) / textWidth);

        for (let i = 0; i < repeatCount; i++) {
            const clone = span.cloneNode(true);
            inner.appendChild(clone);
        }
    }

    buildMarquee();

    window.addEventListener("resize", () => {
        buildMarquee();
    });
});
